import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { MCButton, Spinner, TextField } from 'src/components/basic';
import AlertManager from 'src/components/alert/AlertManager';
import PopupSelect from 'src/components/complex/popupSelect';

import { withRouter, lang, remCss, addressObject } from 'src/helpers';
import { BASE_ICONS } from 'src/components/svg';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

class CreateDoctor extends BaseComponent {
  componentDidMount() {
    model.baseSubscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    model.resetApiState('update');
    model.setState({ hospitalIds: [], doctor: null });
    if (this.props.router.params.id) {
      model.doctorDetail(parseInt(this.props.router.params.id), (err) => {
        if (err) this.back();
      });
    } else this.back();
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  renderLocation = () => {
    const apiStateId = 'update';
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const handleChange = model.handleChange;

    return (
      <PopupSelect
        template={6}
        isMultiple={true}
        isClearable={false}
        placeholder={'Select'}
        label={'Locations'}
        description={LANG_CONST.text.select_location_des}
        NoResultsElement={({ hide }) => (
          <div>
            <div>{lang.t(LANG_CONST.text.need_location)}</div>
            <div style={{ marginTop: remCss(20), display: 'flex', justifyContent: 'center' }}>
              <MCButton
                primary
                dark
                medium
                radius
                label='Add location'
                onClick={() => {
                  this.navigate('/settings/location');
                  hide();
                }}
              />
            </div>
          </div>
        )}
        defaultValue={false}
        initSelectedParamKey={'hospitalIds'}
        apiConfig={{
          url: 'clinic/manager/hospitals',
          activeDoctors: true,
          labelFn: (item) => (
            <div className={'mc-flex-0-col'}>
              <div className={'mc-text-518'}>{item.hospital?.split('_')[0]}</div>
              <div className={'mc-label-416'}>
                {
                  addressObject({
                    cityAddress: item.city,
                    stateAddress: item.state,
                    countryAddress: item.country
                  }).fullAddressNameReverse
                }
              </div>
            </div>
          )
        }}
        name={'hospitalIds'}
        invalid={invalid}
        value={model.input('hospitalIds')}
        onChange={(n, v) => {
          model.resetApiState(apiStateId);
          handleChange(n, v);
        }}
      />
    );
  };

  render() {
    if (model.getApiState('doctor_detail').loading)
      return (
        <div className={'mc-m-auto'}>
          <Spinner />
        </div>
      );
    const apiStateId = 'update';

    const createState = model.getApiState(apiStateId);
    const { loading } = createState;

    const header = (
      <div className={'mc-container-content__header mc-flex'}>
        <MCButton
          onClick={this.back}
          iconname={BASE_ICONS.BACK_ARROW}
          circle
          primary
          dark
          width={40}
        />
        <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.edit_doctor)}</span>
      </div>
    );

    return (
      <div className={'mc-container-content'}>
        {header}
        <div className={'mc-container-content__body'}>
          <>
            <div
              className={'mc-container-content__body-content border'}
              style={{ alignItems: 'center' }}
            >
              <div
                className={'mc-flex-20-col'}
                style={{ width: '100%', maxWidth: remCss(700), marginTop: remCss(10) }}
              >
                <div className={'mc-flex-20'}>
                  <TextField
                    label='Full name'
                    disabled={true}
                    placeholder='Enter full name'
                    value={model.input('fullname')}
                    name={'fullname'}
                    onChange={() => {}}
                    template={6}
                  />
                </div>
                <div className={'mc-flex-20 mc-flex-start'}>
                  <TextField
                    label='Email'
                    disabled={true}
                    placeholder='uname@mail.com'
                    type='email'
                    name='email'
                    value={model.input('email')}
                    onChange={() => {}}
                    template={6}
                  />
                  <TextField
                    template={6}
                    disabled={true}
                    defaultCountryName={model.state.tempCountryAddress}
                    name={'phoneNumber'}
                    type='phone'
                    value={model.input('phoneNumber').toString()}
                    onChange={() => {}}
                    label={'Phone number'}
                  />
                </div>
                <div className={'mc-flex-20'}>{this.renderLocation()}</div>
              </div>
            </div>

            <div className={'mc-container-content__body-footer'}>
              <div className={'mc-flex'}>
                <div className={'mc-grow'}></div>
                <MCButton
                  primary
                  medium
                  dark
                  radius
                  disabled={loading}
                  loading={loading}
                  label={LANG_CONST.buttons.edit}
                  onClick={() => {
                    model.updateDoctor(this.props.router.params.id, (err, data, success) => {
                      if (success) {
                        AlertManager.popup(AlertManager.TYPES.INFO, {
                          close: false,
                          title: LANG_CONST.notice.change_success,
                          width: 400,
                          cancelButton: {
                            label: LANG_CONST.buttons.ok,
                            action: (actions) => {
                              actions.hide();
                            }
                          }
                        });
                      }
                    });
                  }}
                />
              </div>
            </div>
          </>
        </div>
      </div>
    );
  }
}

export default withRouter(CreateDoctor);
